let _ = t => t,
  _t;
import { MY_PLAYLISTS_URL_FRAGMENT } from '../../../constants/Navigation.legacy';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BackButton } from '../../navigation';
import styledWithTheme from 'foundations-theming/utils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PlaylistBackButton = styledWithTheme(BackButton)(_t || (_t = _`
  ${0}
  ${0}
`), ({
  $isMobile,
  theme
}) => $isMobile && `color: ${theme.color['text-interactive-default']} !important;`, ({
  $isNotMobile,
  theme
}) => $isNotMobile && `color: ${theme.color['text-core-on-fill-default']} !important;`);
export const PlaylistPageHeader = () => {
  const {
    isMobile,
    isNotMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isMobile && /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      backgroundColor: "fill-surface-default",
      inlineSize: "100%",
      justifyContent: "space-between",
      paddingInline: "400",
      children: /*#__PURE__*/_jsx(View, {
        paddingBlock: "200",
        children: /*#__PURE__*/_jsx(PlaylistBackButton, {
          $isMobile: isMobile,
          $isNotMobile: isNotMobile,
          exact: true,
          to: MY_PLAYLISTS_URL_FRAGMENT,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.playlists.myPlaylists"
          })
        })
      })
    })
  });
};